import { useLayoutEffect, useRef } from 'react';
import classes from './MsgContainer.module.scss'
import { useSelector } from 'react-redux';
import { useTranslate } from '@educaplay/core';

export default function MsgContainer() {
    const t = useTranslate();
    const MESSAGE_TYPE = {

        "escrita": "",
        "unica": "",
        "multiple": t('specific.messageQuestion')

    }

    const msgContainer = useRef();
    const question = useSelector(state => state.game.questions[state.game.currentIndex]);


    useLayoutEffect(() => {
        const resizeObserver = new ResizeObserver(entries => {
            const msgHeight = entries[0].target.getBoundingClientRect().height;
            document.documentElement.style.setProperty('--msg-height', msgHeight + 'px');
        });

        if (msgContainer.current) {
            resizeObserver.observe(msgContainer.current);
        }

        return () => {
            resizeObserver.disconnect();
        };
    }, []);

    return (
        <div className={classes.messageContainer}>
            <div className={classes.message} ref={msgContainer}>
                {MESSAGE_TYPE[question.questionType]}
            </div>
        </div>
    )
}